import React from 'react'
export const girls = {
  regions: {
    left: [
      {
        id: 'category',
        title: 'Shop by Category',
        links: [
          {target: '#', text: 'Shop New', src: 'https://d2lknnt52h7uhg.cloudfront.net/roa-canon/web/megamenu/NAV_G_NewArrivals.jpg'},
          {target: '#', text: 'Best Sellers', src: 'https://d2lknnt52h7uhg.cloudfront.net/roa-canon/web/megamenu/NAV_G_BestSellers.jpg'},
          {target: '#', text: 'Graphics Shop', src: 'https://d2lknnt52h7uhg.cloudfront.net/roa-canon/web/megamenu/NAV_G_GraphicTees.jpg'},
          {target: '#', text: 'Tees & Tops', src: 'https://d2lknnt52h7uhg.cloudfront.net/roa-canon/web/megamenu/NAV_G_Tops.jpg'},
          {target: '#', text: 'Sweatshirts', src: 'https://d2lknnt52h7uhg.cloudfront.net/roa-canon/web/megamenu/NAV_G_Sweats.jpg'},
          {target: '#', text: 'Dresses & Skirts', src: 'https://d2lknnt52h7uhg.cloudfront.net/roa-canon/web/megamenu/NAV_G_Dresses.jpg'},
          {target: '#', text: 'Leggings & Sweatpants', src: 'https://d2lknnt52h7uhg.cloudfront.net/roa-canon/web/megamenu/NAV_G_Pants.jpg'},
          {target: '#', text: 'Active', src: 'https://d2lknnt52h7uhg.cloudfront.net/roa-canon/web/megamenu/NAV_G_Active.jpg'},
          {target: '#', text: 'Outerwear', src: 'https://d2lknnt52h7uhg.cloudfront.net/roa-canon/web/megamenu/NAV_G_Outerwear.jpg'},
          {target: '#', text: 'Swim', src: 'https://d2lknnt52h7uhg.cloudfront.net/roa-canon/web/megamenu/NAV_G_Swim.jpg'},
          {target: '#', text: 'Accessories', src: 'https://d2lknnt52h7uhg.cloudfront.net/roa-canon/web/megamenu/NAV_G_Accessories.jpg'},
          {target: '#', text: 'Shop All', src: 'https://d2lknnt52h7uhg.cloudfront.net/roa-canon/web/megamenu/NAV_G_All.jpg'}
        ]
      },
    ],
    right: [
      {
        id: 'story',
        title: 'Shop by Story',
        links: [
          {target: '#', text: 'Next-Level Neon', src: 'https://d2lknnt52h7uhg.cloudfront.net/roa-canon/web/megamenu/NAV_E_Neon.jpg'},
          {target: '#', text: 'Not Your Average Rainbow', src: 'https://d2lknnt52h7uhg.cloudfront.net/roa-canon/web/megamenu/NAV_E_Rainbow.jpg'},
          {target: '#', text: 'Awesome Graffiti', src: 'https://d2lknnt52h7uhg.cloudfront.net/roa-canon/web/megamenu/NAV_E_Graffiti.jpg'},
          {target: '#', text: 'Vacation-Ready Styles', src: 'https://d2lknnt52h7uhg.cloudfront.net/roa-canon/web/megamenu/NAV_E_Vacation.jpg'}
        ]
      },
    ]
  }
}

export const boys = {
  regions: {
    left: [
      {
        id: 'category',
        title: 'Shop by Category',
        links: [
          {target: '#', text: 'Shop New', src: 'https://d2lknnt52h7uhg.cloudfront.net/roa-canon/web/megamenu/NAV_B_NewArrivals.jpg'},
          {target: '#', text: 'Best Sellers', src: 'https://d2lknnt52h7uhg.cloudfront.net/roa-canon/web/megamenu/NAV_B_BestSellers.jpg'},
          {target: '#', text: 'Graphics Shop', src: 'https://d2lknnt52h7uhg.cloudfront.net/roa-canon/web/megamenu/NAV_B_GraphicTees.jpg'},
          {target: '#', text: 'Tees & Tops', src: 'https://d2lknnt52h7uhg.cloudfront.net/roa-canon/web/megamenu/NAV_B_Tops.jpg'},
          {target: '#', text: 'Sweatshirts', src: 'https://d2lknnt52h7uhg.cloudfront.net/roa-canon/web/megamenu/NAV_B_Sweats.jpg'},
          {target: '#', text: 'Pants & Shorts', src: 'https://d2lknnt52h7uhg.cloudfront.net/roa-canon/web/megamenu/NAV_B_Pants.jpg'},
          {target: '#', text: 'Active', src: 'https://d2lknnt52h7uhg.cloudfront.net/roa-canon/web/megamenu/NAV_B_Active.jpg'},
          {target: '#', text: 'Outerwear', src: 'https://d2lknnt52h7uhg.cloudfront.net/roa-canon/web/megamenu/NAV_B_Outerwear.jpg'},
          {target: '#', text: 'Swim', src: 'https://d2lknnt52h7uhg.cloudfront.net/roa-canon/web/megamenu/NAV_B_Swim.jpg'},
          {target: '#', text: 'Accessories', src: 'https://d2lknnt52h7uhg.cloudfront.net/roa-canon/web/megamenu/NAV_B_Accessories.jpg'},
          {target: '#', text: 'Shop All', src: 'https://d2lknnt52h7uhg.cloudfront.net/roa-canon/web/megamenu/NAV_B_All.jpg'}
        ]
      },
    ],
    right: [
      {
        id: 'story',
        title: 'Shop by Story',
        links: [
          {target: '#', text: 'Next-Level Neon', src: 'https://d2lknnt52h7uhg.cloudfront.net/roa-canon/web/megamenu/NAV_E_Neon.jpg'},
          {target: '#', text: 'Awesome Graffiti', src: 'https://d2lknnt52h7uhg.cloudfront.net/roa-canon/web/megamenu/NAV_E_Graffiti.jpg'},
          {target: '#', text: 'Vacation-Ready Styles', src: 'https://d2lknnt52h7uhg.cloudfront.net/roa-canon/web/megamenu/NAV_E_Vacation.jpg'}
        ]
      },
    ]
  }
}

export const accountLinks = {
  loggedOut: {
    text: 'Login',
    target: '/shop/login'
  },
  loggedIn: {
    text: 'User',
    submenu: [

    ]
  }
}

export const renderLink = (inProps) => {
  const { target, children, ...props } = inProps
  return (<a href={target} {...props}>{children}</a>)
}



// WEBPACK FOOTER //
// ./src/modules/header/desktopNavigation/defaultProps.js